import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationLogRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-log',
	path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
	exact: true,
};
